import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import AlertTemplate from "react-alert-template-basic";
import { BrowserRouter } from "react-router-dom";
import { Provider as AlertProvider } from "react-alert";
import { HelmetProvider } from "react-helmet-async";

import { CartProvider } from './cart/index.jsx';
import {
  SettingsContextProvider,
  UserContextProvider,
  FavouritesContextProvider,
  ModalContextProvider,
  FeatureGatingProvider,
  EntitlementsProvider,
  OnboardingProvider,
} from './contexts/index.jsx';
import SiteTitle from "./layouts/SiteTitle";
import DevtoolsGuard from "./layouts/DevtoolsGuard.jsx";
import GA4PageTracker from "./layouts/GA4PageTracker.jsx";
import { EntitlementErrorListener } from "./components/EntitlementErrorListener";
import { ToastProvider } from "./components/ui/Toast";
import { ErrorBoundary, ScrollToTop, Routes, AppShell } from './layouts/index.jsx';
import { queryClient } from "./core/queryClient";

// Import global styles
import "./styles/loader.scss";
import "./styles/style.scss";
import "./styles/retailCircle.scss";

const alertOptions = {
  position: "top right",
  type: "error",
  timeout: 5000,
  offset: "30px",
  transition: "fade",
};

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <HelmetProvider>
          <AlertProvider template={AlertTemplate} {...alertOptions}>
            <ToastProvider>
              <QueryClientProvider client={queryClient}>
              <UserContextProvider>
                <SettingsContextProvider>
                  <FeatureGatingProvider>
                  <EntitlementsProvider>
                    <EntitlementErrorListener />
                    <SiteTitle />
                    <DevtoolsGuard />
                    <GA4PageTracker />

                    <ScrollToTop />

                  <ModalContextProvider>
                    <CartProvider>
                      <FavouritesContextProvider>
                        {/* Inside Entitlements — the checklist hides steps the
                            store isn't entitled to rather than showing them locked. */}
                        <OnboardingProvider>
                          <AppShell>
                            <Routes />
                          </AppShell>
                        </OnboardingProvider>
                      </FavouritesContextProvider>
                    </CartProvider>
                  </ModalContextProvider>
                  </EntitlementsProvider>
                  </FeatureGatingProvider>
                </SettingsContextProvider>
              </UserContextProvider>
              </QueryClientProvider>
            </ToastProvider>
          </AlertProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
